// Module
var code = " ";
// Exports
var _module_exports =code;;
var path = 'app/engage/banner/BannerEdit/guides/BannerEditTranslationsGuideTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;